import { render } from "./PollFeedItem.vue?vue&type=template&id=6161acc4"
import script from "./PollFeedItem.vue?vue&type=script&lang=js"
export * from "./PollFeedItem.vue?vue&type=script&lang=js"

import "./PollFeedItem.vue?vue&type=style&index=0&id=6161acc4&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__